<div class="w-full overflow-x-auto">
  <table
    mat-table
    [dataSource]="users"
    [attr.aria-label]="label | translate">
    <ng-container matColumnDef="user">
      <th
        mat-header-cell
        *matHeaderCellDef>
        {{ "partners.users.columns.user" | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let user">
        <div class="flex flex-col">
          <span class="font-semibold">{{ user.full_name }}</span>
          <a
            class="text-secondary hover:underline"
            [href]="'mailto:' + user.email">
            {{ user.email }}
          </a>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="role">
      <th
        mat-header-cell
        *matHeaderCellDef>
        {{ "partners.users.columns.role" | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let user">
        {{ roleLabels[user.role] | translate }}
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th
        mat-header-cell
        *matHeaderCellDef>
        {{ "partners.users.columns.status" | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let user">
        <span
          class="rms-badge rms-badge_sm"
          [class.success]="user.status === activeStatus"
          [class.danger]="user.status !== activeStatus">
          {{ statusLabels[user.status] | translate }}
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="created_at">
      <th
        mat-header-cell
        *matHeaderCellDef>
        {{ "partners.users.columns.created" | translate }}
      </th>
      <td
        class="whitespace-nowrap"
        mat-cell
        *matCellDef="let user">
        {{ user.created_at | dateFormat: "mediumDate" }}
      </td>
    </ng-container>
    <ng-container
      matColumnDef="actions"
      stickyEnd>
      <th
        mat-header-cell
        *matHeaderCellDef></th>
      <td
        class="w-16"
        mat-cell
        *matCellDef="let user">
        <rms-partner-user-actions
          [actions]="user.id === signedInUserId ? signedInUserActions : actions"
          [loading]="!!deleting[user.id]"
          (selected)="action.emit({ user, action: $event })" />
      </td>
    </ng-container>
    <tr
      mat-header-row
      *matHeaderRowDef="columns"></tr>
    <tr
      mat-row
      *matRowDef="let user; columns: columns"></tr>
    <tr
      class="mat-row"
      *matNoDataRow>
      <td
        class="mat-cell"
        [attr.colspan]="columns.length">
        <p class="px-3.5">{{ (filtered ? "partners.users.no-results" : emptyMessage) | translate }}</p>
      </td>
    </tr>
  </table>
</div>
